
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexkpuWaDRav7fDrWKOjsGgEcW3CxcUrcAdcBqHZPBl2q0Meta } from "/codebuild/output/src438516980/src/pages/index.vue?macro=true";
import { default as indexvaa_45Z8_Le6b_45apPOCSBASWWyKSmdLmBcYC3aNTppCF0Meta } from "/codebuild/output/src438516980/src/pages/login/index.vue?macro=true";
import { default as indexebTvBgkZ_C9hlLo4dmEM77JgzcRa2eZkSeZJWDs031wMeta } from "/codebuild/output/src438516980/src/pages/software/index.vue?macro=true";
import { default as indexAWruAFmkSmJQQz4VHfIYjSGVfqOAdMN3HW98o0XRh3EMeta } from "/codebuild/output/src438516980/src/pages/trackers/index.vue?macro=true";
import { default as index1Aqs3qn0i7p0pfyFX5qw7i_ENY7h6a43wWEo5bosPC8Meta } from "/codebuild/output/src438516980/src/pages/templates/index.vue?macro=true";
import { default as createRfD5Y6IPxu07dKsBQ7YlyimSkKpKopANuN_454O3qceOAMeta } from "/codebuild/output/src438516980/src/pages/trackers/create.vue?macro=true";
import { default as createDTr8OI8bWbfyYBRKZRH8QxGuxaLChNdrFobk3L_6aQIMeta } from "/codebuild/output/src438516980/src/pages/templates/create.vue?macro=true";
import { default as indexfRj0NMEzcavDS1eVOC4GJLQ7vhRztK9YpyjE8sLAG5IMeta } from "/codebuild/output/src438516980/src/pages/tagging-docs/index.vue?macro=true";
import { default as editRMsGQbwxd0za3HdMoWNHyA4TGbgBMiYBckGuBEmly_45AMeta } from "/codebuild/output/src438516980/src/pages/trackers/[id]/edit.vue?macro=true";
import { default as _91token_93rtKB1K4iD5yzTgNBNyyNhFX_WCEaFM7jg2t6LI5mC6UMeta } from "/codebuild/output/src438516980/src/pages/login/token/[token].vue?macro=true";
import { default as edit_45_45moAedUJBGvRUpysji4TEWGTtSkU7Ekvi6n8_yoG6AMeta } from "/codebuild/output/src438516980/src/pages/templates/[id]/edit.vue?macro=true";
import { default as indexV8YOELR_45GEsoXqfFI7NByCWx9KzwSFMJx_45EdwMx6VRQMeta } from "/codebuild/output/src438516980/src/pages/templates/[id]/index.vue?macro=true";
import { default as index449X06NQV6b2eiCRhKIS3pbpuDuPljvWFAmFYVf08VUMeta } from "/codebuild/output/src438516980/src/pages/plan-management/index.vue?macro=true";
import { default as indexXpMO3spKv2z9gJXo9Bvwdzmnbyreiyh5_6eiZk7G3JwMeta } from "/codebuild/output/src438516980/src/pages/dropcode-generator/index.vue?macro=true";
import { default as indexT0t5N3NVgKR0D3t_45vS04wZGbRTthWQim_hUBsxUfGnEMeta } from "/codebuild/output/src438516980/src/pages/standalone-snowplow/index.vue?macro=true";
import { default as indexXb7n9CuHQBDW1g793vIn44cpdVMH5LH4J1rJVlLknOcMeta } from "/codebuild/output/src438516980/src/pages/trackers/[id]/events/index.vue?macro=true";
import { default as index9h361U04Hd9oyh2hbcZZxkYTyZhv9puy1sK_4595t4de8Meta } from "/codebuild/output/src438516980/src/pages/plan-management/[id]/events/index.vue?macro=true";
import { default as create4lmsBRXDRzWidf0IPPUOwdYTXkuVoAE_ErfrNQon7ZYMeta } from "/codebuild/output/src438516980/src/pages/plan-management/[id]/events/create.vue?macro=true";
import { default as editRrarF6JXLHH_45k0tNN80cDUkDRbJ_454OlS2LS3sG4XRy8Meta } from "/codebuild/output/src438516980/src/pages/plan-management/[id]/events/[eventId]/edit.vue?macro=true";
import { default as eventsx9xiMW0Vq_45m00J_45f8fpDmJqp6_45QkTXrHhi6tR0OjuXcMeta } from "/codebuild/output/src438516980/src/pages/plan-management/[id]/events.vue?macro=true";
import { default as index6OqfjOZWqD3bdkCo8VY5NdguaWmccYIjEq_45rXWcsUycMeta } from "/codebuild/output/src438516980/src/pages/templates/[id]/events/index.vue?macro=true";
import { default as createTmFbYmo8xfMXK8pSrznfgu4BvcQGQVHOe2lDkVy0edgMeta } from "/codebuild/output/src438516980/src/pages/trackers/[id]/events/create.vue?macro=true";
import { default as assign_45groupsfl24LgYC3JEcTkaoDkHPSDulvipycfbmUILYxYtlwqwMeta } from "/codebuild/output/src438516980/src/pages/templates/[id]/assign-groups.vue?macro=true";
import { default as createoARsx8PzfZB3ILiWS5vDlkzOYYVHGK_FfttKvb3WWasMeta } from "/codebuild/output/src438516980/src/pages/templates/[id]/events/create.vue?macro=true";
import { default as indextMKAGh5W_45dY2w6_45yKsfm_45UlONIbTUaKh2TsgtI7HUa8Meta } from "/codebuild/output/src438516980/src/pages/trackers/[id]/transformers/index.vue?macro=true";
import { default as indexzMV5fVpJpiRJjEgYLgAojnRYesAP9pmpn_45s5uZCqn20Meta } from "/codebuild/output/src438516980/src/pages/templates/[id]/transformers/index.vue?macro=true";
import { default as createxC20hha1hXaV2igR6bvGaAAbMIH15KB6FrbCuwIU7ZMMeta } from "/codebuild/output/src438516980/src/pages/trackers/[id]/transformers/create.vue?macro=true";
import { default as retain_45backendt_45od8CDI_45TskIM2rUUM9rDvs1Wei0ErYLWF4w2VNwDgMeta } from "/codebuild/output/src438516980/src/pages/standalone-snowplow/retain-backend.vue?macro=true";
import { default as createQrjbNZ3TygzSBnt_45CpjsYlkmfTpUiR55_45amjmdgOHH4Meta } from "/codebuild/output/src438516980/src/pages/templates/[id]/transformers/create.vue?macro=true";
import { default as retain_45frontendPN_CXREqCZq9iw9lMhusc9E_qhqo3442bFFpnW86BaoMeta } from "/codebuild/output/src438516980/src/pages/standalone-snowplow/retain-frontend.vue?macro=true";
import { default as BaseSoftwarePageU7LNi5GzLosNRbT5raFUTKxEZbD6XE9ahWbt8Xn_tCYMeta } from "/codebuild/output/src438516980/src/pages/standalone-snowplow/BaseSoftwarePage.vue?macro=true";
import { default as indexK4hRDk0cC3xBL6GCrNj_45lxQPiVkQw7aZboqqKXkDMl0Meta } from "/codebuild/output/src438516980/src/pages/trackers/[id]/events/[eventId]/index.vue?macro=true";
import { default as index9VxTE0QYm4UUOsFxZuXerwZpsc8Q0pPb7gvPQ55CSeUMeta } from "/codebuild/output/src438516980/src/pages/templates/[id]/events/[eventId]/index.vue?macro=true";
import { default as netdirector_45ownershipGn4uvuOljz9QS9l6fVp3vRUTCAKx_45B1_ttZ9FyriT_gMeta } from "/codebuild/output/src438516980/src/pages/standalone-snowplow/netdirector-ownership.vue?macro=true";
import { default as index0JfXbP4GvFZ_45R5z20jQBhuP6bZe5y6D0yxiogG7Z1fEMeta } from "/codebuild/output/src438516980/src/pages/trackers/[id]/events/[eventId]/edit/index.vue?macro=true";
import { default as indexg7q7a4rgjiTNo4joZ4gHjt3v8l1ahi4JjhPCz3RKYzIMeta } from "/codebuild/output/src438516980/src/pages/templates/[id]/events/[eventId]/edit/index.vue?macro=true";
import { default as jlr_45global_45avl_45frontend5UQAti8mlmtbXIPAl_N5zBcgbWrxWrA6fkXK0paXeXEMeta } from "/codebuild/output/src438516980/src/pages/standalone-snowplow/jlr-global-avl-frontend.vue?macro=true";
import { default as netdirector_45experience_45v21MTpeJ5f9xhzbFTn41w1g0DFsSiA2EW1a5grynkvk9QMeta } from "/codebuild/output/src438516980/src/pages/standalone-snowplow/netdirector-experience-v2.vue?macro=true";
import { default as editXQC7eKRQfsWFbHQGBzP2pZCqWnSDSgXabl9Wfev7bUkMeta } from "/codebuild/output/src438516980/src/pages/trackers/[id]/transformers/[transformerId]/edit.vue?macro=true";
import { default as editEsNuk5A2_TNEvV4_45IHCtERCfAMSHBrKCEgq0rumR4J0Meta } from "/codebuild/output/src438516980/src/pages/templates/[id]/transformers/[transformerId]/edit.vue?macro=true";
import { default as netdirector_45frontend_45componentskgsMhK4rPXp6ncqPRoyACtxB7CGq_45KUstaW5An_45uhY8Meta } from "/codebuild/output/src438516980/src/pages/standalone-snowplow/netdirector-frontend-components.vue?macro=true";
import { default as netdirector_45online_45vehicle_45sales_45oqB66ERujTvz3YjN22FmdL8XDfdi7g_fzSEeGALllEMeta } from "/codebuild/output/src438516980/src/pages/standalone-snowplow/netdirector-online-vehicle-sales.vue?macro=true";
import { default as indexK_8ytqrsiOJP_451PaiIEZU7N7VC_45xOoj7t7l6BBNoDvIMeta } from "/codebuild/output/src438516980/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue?macro=true";
import { default as indexL5cttIR60uhJjAqwsYHnAgptNAxZpufcaZDWpK4KStAMeta } from "/codebuild/output/src438516980/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue?macro=true";
import { default as createHrUnN2UEVHXgUt9wynRmyqM1odiLAignMv0DPc_eGa8Meta } from "/codebuild/output/src438516980/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue?macro=true";
import { default as createmxTR_45NKKzLuAQMvN9hoyYn_2hVx9b0AuzGCwF3gslsoMeta } from "/codebuild/output/src438516980/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue?macro=true";
import { default as edit6J0Up9uPTymi0OuYzuj7E0AEoVOKQNud9DuQKYuFA94Meta } from "/codebuild/output/src438516980/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue?macro=true";
import { default as editK8m6Of59ralzLMzYorzxkgMXpeqjdYkHyYKN83cp28sMeta } from "/codebuild/output/src438516980/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src438516980/src/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: {"middleware":"auth"},
    component: () => import("/codebuild/output/src438516980/src/pages/login/index.vue")
  },
  {
    name: "software",
    path: "/software",
    component: () => import("/codebuild/output/src438516980/src/pages/software/index.vue")
  },
  {
    name: "trackers",
    path: "/trackers",
    component: () => import("/codebuild/output/src438516980/src/pages/trackers/index.vue")
  },
  {
    name: "templates",
    path: "/templates",
    component: () => import("/codebuild/output/src438516980/src/pages/templates/index.vue")
  },
  {
    name: "trackers-create",
    path: "/trackers/create",
    component: () => import("/codebuild/output/src438516980/src/pages/trackers/create.vue")
  },
  {
    name: "templates-create",
    path: "/templates/create",
    component: () => import("/codebuild/output/src438516980/src/pages/templates/create.vue")
  },
  {
    name: "tagging-docs",
    path: "/tagging-docs",
    component: () => import("/codebuild/output/src438516980/src/pages/tagging-docs/index.vue")
  },
  {
    name: "trackers-id-edit",
    path: "/trackers/:id()/edit",
    component: () => import("/codebuild/output/src438516980/src/pages/trackers/[id]/edit.vue")
  },
  {
    name: "login-token-token",
    path: "/login/token/:token()",
    component: () => import("/codebuild/output/src438516980/src/pages/login/token/[token].vue")
  },
  {
    name: "templates-id-edit",
    path: "/templates/:id()/edit",
    component: () => import("/codebuild/output/src438516980/src/pages/templates/[id]/edit.vue")
  },
  {
    name: "templates-id",
    path: "/templates/:id()",
    component: () => import("/codebuild/output/src438516980/src/pages/templates/[id]/index.vue")
  },
  {
    name: "plan-management",
    path: "/plan-management",
    component: () => import("/codebuild/output/src438516980/src/pages/plan-management/index.vue")
  },
  {
    name: "dropcode-generator",
    path: "/dropcode-generator",
    component: () => import("/codebuild/output/src438516980/src/pages/dropcode-generator/index.vue")
  },
  {
    name: "standalone-snowplow",
    path: "/standalone-snowplow",
    component: () => import("/codebuild/output/src438516980/src/pages/standalone-snowplow/index.vue")
  },
  {
    name: "trackers-id-events",
    path: "/trackers/:id()/events",
    component: () => import("/codebuild/output/src438516980/src/pages/trackers/[id]/events/index.vue")
  },
  {
    name: eventsx9xiMW0Vq_45m00J_45f8fpDmJqp6_45QkTXrHhi6tR0OjuXcMeta?.name,
    path: "/plan-management/:id()/events",
    component: () => import("/codebuild/output/src438516980/src/pages/plan-management/[id]/events.vue"),
    children: [
  {
    name: "plan-management-id-events",
    path: "",
    component: () => import("/codebuild/output/src438516980/src/pages/plan-management/[id]/events/index.vue")
  },
  {
    name: "plan-management-id-events-create",
    path: "create",
    component: () => import("/codebuild/output/src438516980/src/pages/plan-management/[id]/events/create.vue")
  },
  {
    name: "plan-management-id-events-eventId-edit",
    path: ":eventId()/edit",
    component: () => import("/codebuild/output/src438516980/src/pages/plan-management/[id]/events/[eventId]/edit.vue")
  }
]
  },
  {
    name: "templates-id-events",
    path: "/templates/:id()/events",
    component: () => import("/codebuild/output/src438516980/src/pages/templates/[id]/events/index.vue")
  },
  {
    name: "trackers-id-events-create",
    path: "/trackers/:id()/events/create",
    component: () => import("/codebuild/output/src438516980/src/pages/trackers/[id]/events/create.vue")
  },
  {
    name: "templates-id-assign-groups",
    path: "/templates/:id()/assign-groups",
    component: () => import("/codebuild/output/src438516980/src/pages/templates/[id]/assign-groups.vue")
  },
  {
    name: "templates-id-events-create",
    path: "/templates/:id()/events/create",
    component: () => import("/codebuild/output/src438516980/src/pages/templates/[id]/events/create.vue")
  },
  {
    name: "trackers-id-transformers",
    path: "/trackers/:id()/transformers",
    component: () => import("/codebuild/output/src438516980/src/pages/trackers/[id]/transformers/index.vue")
  },
  {
    name: "templates-id-transformers",
    path: "/templates/:id()/transformers",
    component: () => import("/codebuild/output/src438516980/src/pages/templates/[id]/transformers/index.vue")
  },
  {
    name: "trackers-id-transformers-create",
    path: "/trackers/:id()/transformers/create",
    component: () => import("/codebuild/output/src438516980/src/pages/trackers/[id]/transformers/create.vue")
  },
  {
    name: "standalone-snowplow-retain-backend",
    path: "/standalone-snowplow/retain-backend",
    component: () => import("/codebuild/output/src438516980/src/pages/standalone-snowplow/retain-backend.vue")
  },
  {
    name: "templates-id-transformers-create",
    path: "/templates/:id()/transformers/create",
    component: () => import("/codebuild/output/src438516980/src/pages/templates/[id]/transformers/create.vue")
  },
  {
    name: "standalone-snowplow-retain-frontend",
    path: "/standalone-snowplow/retain-frontend",
    component: () => import("/codebuild/output/src438516980/src/pages/standalone-snowplow/retain-frontend.vue")
  },
  {
    name: "standalone-snowplow-BaseSoftwarePage",
    path: "/standalone-snowplow/BaseSoftwarePage",
    component: () => import("/codebuild/output/src438516980/src/pages/standalone-snowplow/BaseSoftwarePage.vue")
  },
  {
    name: "trackers-id-events-eventId",
    path: "/trackers/:id()/events/:eventId()",
    component: () => import("/codebuild/output/src438516980/src/pages/trackers/[id]/events/[eventId]/index.vue")
  },
  {
    name: "templates-id-events-eventId",
    path: "/templates/:id()/events/:eventId()",
    component: () => import("/codebuild/output/src438516980/src/pages/templates/[id]/events/[eventId]/index.vue")
  },
  {
    name: "standalone-snowplow-netdirector-ownership",
    path: "/standalone-snowplow/netdirector-ownership",
    component: () => import("/codebuild/output/src438516980/src/pages/standalone-snowplow/netdirector-ownership.vue")
  },
  {
    name: "trackers-id-events-eventId-edit",
    path: "/trackers/:id()/events/:eventId()/edit",
    component: () => import("/codebuild/output/src438516980/src/pages/trackers/[id]/events/[eventId]/edit/index.vue")
  },
  {
    name: "templates-id-events-eventId-edit",
    path: "/templates/:id()/events/:eventId()/edit",
    component: () => import("/codebuild/output/src438516980/src/pages/templates/[id]/events/[eventId]/edit/index.vue")
  },
  {
    name: "standalone-snowplow-jlr-global-avl-frontend",
    path: "/standalone-snowplow/jlr-global-avl-frontend",
    component: () => import("/codebuild/output/src438516980/src/pages/standalone-snowplow/jlr-global-avl-frontend.vue")
  },
  {
    name: "standalone-snowplow-netdirector-experience-v2",
    path: "/standalone-snowplow/netdirector-experience-v2",
    component: () => import("/codebuild/output/src438516980/src/pages/standalone-snowplow/netdirector-experience-v2.vue")
  },
  {
    name: "trackers-id-transformers-transformerId-edit",
    path: "/trackers/:id()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src438516980/src/pages/trackers/[id]/transformers/[transformerId]/edit.vue")
  },
  {
    name: "templates-id-transformers-transformerId-edit",
    path: "/templates/:id()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src438516980/src/pages/templates/[id]/transformers/[transformerId]/edit.vue")
  },
  {
    name: "standalone-snowplow-netdirector-frontend-components",
    path: "/standalone-snowplow/netdirector-frontend-components",
    component: () => import("/codebuild/output/src438516980/src/pages/standalone-snowplow/netdirector-frontend-components.vue")
  },
  {
    name: "standalone-snowplow-netdirector-online-vehicle-sales",
    path: "/standalone-snowplow/netdirector-online-vehicle-sales",
    component: () => import("/codebuild/output/src438516980/src/pages/standalone-snowplow/netdirector-online-vehicle-sales.vue")
  },
  {
    name: "trackers-id-events-eventId-edit-fields-fieldId-transformers",
    path: "/trackers/:id()/events/:eventId()/edit/fields/:fieldId()/transformers",
    component: () => import("/codebuild/output/src438516980/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue")
  },
  {
    name: "templates-id-events-eventId-edit-fields-fieldId-transformers",
    path: "/templates/:id()/events/:eventId()/edit/fields/:fieldId()/transformers",
    component: () => import("/codebuild/output/src438516980/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue")
  },
  {
    name: "trackers-id-events-eventId-edit-fields-fieldId-transformers-create",
    path: "/trackers/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/create",
    component: () => import("/codebuild/output/src438516980/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue")
  },
  {
    name: "templates-id-events-eventId-edit-fields-fieldId-transformers-create",
    path: "/templates/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/create",
    component: () => import("/codebuild/output/src438516980/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue")
  },
  {
    name: "trackers-id-events-eventId-edit-fields-fieldId-transformers-transformerId-edit",
    path: "/trackers/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src438516980/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue")
  },
  {
    name: "templates-id-events-eventId-edit-fields-fieldId-transformers-transformerId-edit",
    path: "/templates/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src438516980/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue")
  }
]